import { observable, action, makeObservable, runInAction } from "mobx"
import { createVariableData, getVariableDetailsById, updateVariableDataById } from "../adapters/VariableDetailsAdapter"
import { RootStoreType } from ".";

export class VariableDetailsStore {
  selectedVariable: number = -1;
  selectedVariableDetails: VariableDetail | undefined
  isLoadingVariableDetails: boolean = false
  error: string | null = null;
  toastData: ToastData | null = { message: "Test Message", variant: "error" };
  rootStore: RootStoreType | null = null;

  constructor(root: RootStoreType) {
    this.rootStore = root;
    return makeObservable(this, {
      selectedVariable: observable,
      selectedVariableDetails: observable,
      error: observable,
      selectVariableForViewing: action,
      setSelectedVariableDetails: action,
      clearSelectVariable: action,
      fetchDetailsOfSelectedVariable: action,
      createVariableDetails: action,
      updateVariableDetails: action,
      updateVariableDetailsForCreate: action,
      toastData: observable,
    })
  }

  selectVariableForViewing = (id: number) => {
    this.selectedVariable = id;
    this.fetchDetailsOfSelectedVariable();
  }

  setSelectedVariableDetails = (newVariable: VariableDetail) => {
    this.selectedVariableDetails = newVariable;
  }

  clearSelectVariable = () => {
    this.selectedVariable = -1;
  }

  fetchDetailsOfSelectedVariable = () => {

    if (!this.isLoadingVariableDetails) {
      this.isLoadingVariableDetails = true
      getVariableDetailsById(this.selectedVariable).then((response) => {
        if(response.data.value_names){
          let valueNamesArray:Array<ValueNamesObjectType> = [];
          Object.keys(response.data.value_names).forEach((key:string)=>{
            valueNamesArray.push({hexCode:key,name:response.data.value_names[key]})
          })
          response.data.value_names = valueNamesArray;
        }

        this.selectedVariableDetails = response.data;
        this.isLoadingVariableDetails = false
      }).catch((error: any) => {
        console.log('error', error)
      });
    }
  }

  createVariableDetails = async (requestPayload: any) => {
    this.isLoadingVariableDetails = true;
    try {
      const response = await createVariableData(requestPayload);
      runInAction(() => {
        this.isLoadingVariableDetails = false;
        this.rootStore?.toastStore?.addToast("Created variable successfully", "success");
        this.rootStore?.variableListStore.loadVariables();
        this.selectedVariable = response.data
        this.fetchDetailsOfSelectedVariable();
      });
    } catch (error: any) {
      runInAction(() => {
        this.error = error.message;
        this.isLoadingVariableDetails = false;
        this.rootStore?.toastStore?.addToast("Create variable failed with message " + error.message, "error");
      });
    }
  }

  updateVariableDetails = async (id: number, requestPayload: any) => {
    this.isLoadingVariableDetails = true;
    try {
      await updateVariableDataById(id, requestPayload);
      runInAction(() => {
        this.isLoadingVariableDetails = false;
        this.rootStore?.toastStore?.addToast("Variable successfully updated.","success");
        this.rootStore?.variableListStore.loadVariables();
      });
    } catch (error: any) {
      runInAction(() => {
        this.error = error.message;
        this.isLoadingVariableDetails = false;
        this.rootStore?.toastStore?.addToast("Variable updateing failed with message "+ error.message, "error");
      });
    }
  }

  updateVariableDetailsForCreate = (variableData: VariableDetail) => {
    this.selectedVariable = 0;
    this.selectedVariableDetails = variableData;
  }
}